
import { mapActions, mapGetters } from 'vuex'
import MapTool from '../../components/page/mapTool'
import ChartContainer from '../../components/page/chartContainer'
import { capitalize, renderText } from '../../utils/StringUtils'
import EnerDownloadFloatingButton from '../../components/ui/enerDownloadFloatingButton'
import BenchmarkBuilder from '../../components/page/benchmarkBuilder'

export default {
  components: { BenchmarkBuilder, EnerDownloadFloatingButton, ChartContainer, MapTool },
  beforeRouteUpdate (to, from, next) {
    this.clearMapCountry()
    this.clearBenchmarkCountries()
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.clearMapCountry()
    this.clearBenchmarkCountries()
    next()
  },
  validate ({ params }) {
    return /.html$/.test(params.page)
  },
  data () {
    return {
      values: []
    }
  },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.pageContent.seo.title,
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageContent.seo.description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.pageContent.seo.keywords
        },
        {
          property: 'og:type',
          content: 'website'
        },
        {
          property: 'og:title',
          content: this.pageContent.seo.title
        },
        {
          property: 'og:url',
          content: 'https://' + this.$i18n.localeProperties.domain + this.$route.fullPath
        },
        {
          property: 'og:description',
          content: this.pageContent.seo.description
        },
        {
          property: 'twitter:card',
          content: 'summary'
        },
        {
          property: 'twitter:site',
          content: '@Enerdata'
        },
        {
          property: 'twitter:title',
          content: this.pageContent.seo.title
        },
        {
          property: 'twitter:description',
          content: this.pageContent.seo.description
        },
        ...i18nHead.meta
      ],
      link: [
        ...this.injectAlternateLinkHrefs(i18nHead.link)
      ]
    }
  },
  computed: {
    ...mapGetters({
      world: 'world',
      pages: 'pages',
      pageContent: 'page/pageContent',
      mapContent: 'page/mapContent',
      mapCountry: 'page/mapCountry',
      benchmarkCountries: 'page/benchmarkCountries',
      isMobileLayout: 'isMobileLayout'
    }),
    mapUnitName () {
      if (this.mapContent !== undefined) {
        return this.$options.filters.unitName(this.mapContent.displayUnit)
      }
      return ''
    },
    pageLandscapeImage () {
      return require(`@/assets/images/jumbotron/${this.pageContent.jumbotron}.jpg`)
    },
    selectedCountriesTitle () {
      if (this.benchmarkCountries.length > 0) {
        return this.$i18n.t('page.benchmarkTitle')
      }
      return this.mapCountry['name' + capitalize(this.$i18n.locale)]
    },
    isNotWorldDisplay () {
      return this.benchmarkCountries.length > 0 || this.mapCountry !== this.world
    },
    graph1Title () {
      return this.pageContent.graph1.titre
        .replace('{{yearMin}}', this.$config.minDataYear)
        .replace('{{yearMax}}', this.$config.maxDataYear)
    },
    graph1nbCol () {
      if (!this.graph2Exist) {
        return 12
      }
      return 8
    },
    graph2Exist () {
      return this.pageContent.graph2 !== undefined && this.benchmarkCountries.length === 0
    },
    graph2Title () {
      return this.pageContent.graph2.titre
        .replace('$annee', this.pageContent.graph2.years)
    },
    keyText () {
      return renderText(this.$md.renderInline(this.pageContent.keys.data.text))
    },
    tagline () {
      return renderText(this.$md.renderInline(this.pageContent.tagline))
    },
    analyse () {
      return renderText(this.$md.render(this.pageContent.analyse))
    }

  },
  methods: {
    ...mapActions({
      setPageContentForRoutePath: 'page/setPageContentForRoutePath',
      clearPageContent: 'page/clearPageContent',
      clearMapCountry: 'page/clearMapCountry',
      clearBenchmarkCountries: 'page/clearBenchmarkCountries'
    }),
    injectAlternateLinkHrefs (links) {
      // generate alternate link not well managed by nuxt-i18n cause based on page json
      const locales = this.$i18n.locales
      const n = locales.length
      let linkList = []
      for (let i = 0; i < n; i++) {
        const locale = locales[i]
        const pageData = this.pages.find(page => this.pageContent.id === page.id)
        linkList.push({
          hid: `i18n-alt-${locale.iso}`,
          rel: 'alternate',
          href: 'https://' + locale.domain + '/' + pageData.urlCategorie + pageData.url + '.html',
          hreflang: locale.iso
        })
      }
      // retrieve all non alternate link generated by nuxt-i18n (mainly canonical)
      const extraLinks = links.filter(link => link.rel !== 'alternate')
      if (extraLinks.length > 0) {
        linkList = linkList.concat(extraLinks)
      }
      return linkList
    },
    handleBenchmarkClick () {
      this.$bvModal.show('benchmark-modal')
    },
    displayWorld () {
      this.clearMapCountry()
      this.clearBenchmarkCountries()
    }
  }
}
